import React, { useEffect, useState, Fragment } from "react";
import SimpleSelect from "../SimpleSelect";
import { useDispatch } from "react-redux";
import {
  getFollowList,
  getGmailContent,
  getIntelReport,
  getReport,
  getReportData,
  getSideBarData,
  intentFavorite,
} from "../../redux/actions/intentAction";
import { useSelector } from "react-redux";
import Select from "react-tailwindcss-select";
import Loading from "../assetLibComponents/Loading";
import Jump from "../../assets/zoiJump.gif";
import Nike from "../../assets/nikeLogo.svg";
import Logo from "../../assets/Vector.svg";
import { IoFunnelOutline } from "react-icons/io5";
import { IoIosSearch } from "react-icons/io";
import { CiSettings } from "react-icons/ci";
import * as Icon from "react-bootstrap-icons";
import { FaLinkedin, FaStar } from "react-icons/fa";
import { MdOutgoingMail } from "react-icons/md";
import { LuSendHorizonal } from "react-icons/lu";
// import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { Dialog, Transition } from "@headlessui/react";
import { useNavigate } from "react-router";
import { Menu } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { EMAIL_DATA } from "../../constants/IntentActionTypes";
import Markdown from "markdown-to-jsx";

const Intel = (props) => {
  props.pageTypeHandler("Intel");
  let navigate = useNavigate();
  const [sidebar, setSidebar] = useState(true);
  const [sidebarToggle, setSidebarToggle] = useState("All");
  const [freshnessSelected, setFreshnessSelected] = useState({
    id: 1,
    name: "Day",
  });
  const [articleNumber, setArticleNumber] = useState("");
  const [open, setOpen] = useState(false);
  const [openLinkdin, setOpenLinkdin] = useState(false);
  const [fid, setFid] = useState("");
  const [filter, setFilter] = useState("");

  const [formData, setFormData] = useState({
    clientName: "",
    targetIndustries: "",
    aboutSeller: "",
    aboutOffering: "",
  });
  const dispatch = useDispatch();
  const sideData = useSelector((state) => state.intent?.sidebarData);

  const fList = useSelector((state) => state.intent?.followList);
  const isLoading = useSelector((state) => state.intent.loading);
  const nReport = useSelector((state) => state.intent.newsReport);
  const eData = useSelector((state) => state.intent.emailData);

  useEffect(() => {
    dispatch(getFollowList(props.authToken, filter));
  }, [filter]);

  useEffect(() => {
    if (fList?.details?.length > 0) {
      console.log(fList?.details[0]?.follow_id, "id");
      dispatch(getIntelReport(props.authToken, fList?.details[0]?.follow_id));
    }
    if (fList?.details?.length > 0) {
      setFid(fList?.details[0]?.follow_id);
    }
  }, [fList]);

  console.log(fList?.details, "list");

  const handleNews = (id) => {
    setFid(id);
    dispatch(getIntelReport(props.authToken, id));
  };

  const handleGmail = (type, aid, lid) => {
    dispatch({ type: EMAIL_DATA, payload: null });
    dispatch(getGmailContent(props.authToken, aid, fid, lid, type));
  };
  const handleFav = (type) => {
    dispatch(intentFavorite(props.authToken, fid, type, filter, "track"));
  };

  useEffect(() => {
    const uData = JSON.parse(localStorage.getItem("userData"));
    if (!uData?.set_intent) {
      navigate(`/Intel/Setting`);
    }
  }, []);

  const composeEmail = (email, subject, message) => {
    // Construct the mailto link
    const mailtoLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(message)}`;

    // Open the Gmail compose window
    window.open(mailtoLink, "_blank");
  };

  const options = {
    overrides: {
      ul: {
        component: ({ children }) => (
          <ul style={{ listStyleType: "square", marginLeft: "30px" }}>
            {children}
          </ul>
        ),
      },
      li: {
        component: ({ children }) => (
          <li style={{ marginTop: "3px", marginBottom: "3px" }}>{children}</li>
        ),
      },
      ol: {
        component: ({ children }) => (
          <ol
            style={{
              listStyleType: "decimal",
              marginLeft: "20px",
              marginTop: "10px",
            }}
          >
            {children}
          </ol>
        ),
      },
    },
  };

  return (
    <div className="w-full flex">
      <div className="w-[20%] h-[100vh]">
        <div className="pt-20">
          <div className="flex justify-between px-6 my-3">
            <div className="text-lg font-[600] my-auto">Intel</div>
            <div className="flex gap-x-5 my-auto">
              <div className="w-12 text-right">
                <Menu as="div" className="inline-block relative text-left">
                  <div>
                    <Menu.Button className="inline-flex w-full justify-center py-2 text-sm font-medium text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75">
                      <IoFunnelOutline className="text-lg text-gray-400 my-auto" />
                    </Menu.Button>
                  </div>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-0 mt-2 w-24 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
                      <div className="px-1 py-1 ">
                        <Menu.Item>
                          {({ active }) => (
                            <button
                              className={`${
                                active
                                  ? "bg-[#49BCD2] text-white"
                                  : "text-gray-900"
                              } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                              onClick={() => setFilter("")}
                            >
                              All
                            </button>
                          )}
                        </Menu.Item>
                        <Menu.Item>
                          {({ active }) => (
                            <button
                              className={`${
                                active
                                  ? "bg-[#49BCD2] text-white"
                                  : "text-gray-900"
                              } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                              onClick={() => setFilter("account")}
                            >
                              Company
                            </button>
                          )}
                        </Menu.Item>
                        <Menu.Item>
                          {({ active }) => (
                            <button
                              className={`${
                                active
                                  ? "bg-[#49BCD2] text-white"
                                  : "text-gray-900"
                              } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                              onClick={() => setFilter("industry")}
                            >
                              Industry
                            </button>
                          )}
                        </Menu.Item>
                      </div>
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
              {/* <IoIosSearch className="text-xl text-gray-400 my-auto" /> */}
              <CiSettings
                onClick={() => {
                  navigate(`/Intel/Setting`);
                }}
                className="text-2xl cursor-pointer text-gray-400 my-auto"
              />
            </div>
          </div>
          <div className=" text-black flex text-base gap-x-8 px-8 pt-3 cursor-pointer">
            <div
              className={`${
                sidebarToggle == "All"
                  ? "text-black border-solid border-b-2 border-[var(--brand-primary)]"
                  : "text-gray-400"
              } pb-3`}
              onClick={() => {
                setSidebarToggle("All");
              }}
            >
              All
            </div>
            <div
              className={`${
                sidebarToggle == "Starred"
                  ? "text-black border-solid border-b-2 border-[var(--brand-primary)]"
                  : "text-gray-400"
              } pb-3`}
              onClick={() => {
                setSidebarToggle("Starred");
              }}
            >
              Starred
            </div>
          </div>
        </div>
        {sidebarToggle == "All" && (
          <div className="flex-col overflow-y-auto removeScroll h-[70vh]">
            {fList?.details?.length > 0 &&
              fList?.details?.map((item) => {
                return (
                  <div
                    onClick={() => handleNews(item?.follow_id)}
                    className={` ${
                      item?.follow_id == fid ? "bg-blue-100/30" : "bg-white"
                    } hover:bg-blue-100/30 cursor-pointer  border-solid border-gray-100 border-[1px] px-3 py-3 shadow-sm w-full`}
                  >
                    <div className="flex  ">
                      <div className="my-auto mr-2">
                        <img
                          className="w-10 h-10"
                          src={item?.logo_path ?? Logo}
                        />
                      </div>
                      <div className="flex flex-col ml-4">
                        <div
                          className={`font-[500] text-sm text-[var(--brand-primary)] flex`}
                        >
                          {item?.name}
                          {item?.is_favorite && (
                            <span
                              className="my-auto"
                              onClick={() =>
                                handleFav(
                                  nReport?.details?.latest_meta_data
                                    ?.is_favorite == true
                                    ? false
                                    : true
                                )
                              }
                            >
                              <FaStar
                                className={`${
                                  item?.is_favorite && "text-blue-400"
                                } my-auto text-xs cursor-pointer ml-2`}
                              />
                            </span>
                          )}
                        </div>
                        <div className="text-xs">
                          {item?.latest_news_summary?.length > 10
                            ? `${item?.latest_news_summary.slice(0, 30)}...`
                            : `${item?.latest_news_summary}`}
                        </div>
                      </div>
                      <div className="ml-auto my-auto text-[var(--brand-primary)] font-[600] text-sm">
                        {item?.no_of_news_updates > 0 &&
                          !item?.is_seen &&
                          `+${item?.no_of_news_updates}`}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        )}
        {sidebarToggle == "Starred" && (
          <div className="flex-col overflow-y-auto removeScroll h-[70vh]">
            {fList?.details?.length > 0 &&
              fList?.details?.map((item) => {
                return (
                  item?.is_favorite && (
                    <div
                      onClick={() => handleNews(item?.follow_id)}
                      className={` ${
                        item?.follow_id == fid ? "bg-blue-100/30" : "bg-white"
                      } hover:bg-blue-100/30 cursor-pointer  border-solid border-gray-100 border-[1px] px-3 py-3 shadow-sm w-full`}
                    >
                      <div className="flex  ">
                        <div className="my-auto mr-2">
                          <img
                            className="w-10 h-10"
                            src={item?.logo_path ?? Logo}
                          />
                        </div>
                        <div className="flex flex-col ml-4">
                          <div
                            className={`font-[500] text-sm text-[var(--brand-primary)] flex`}
                          >
                            {item?.name}
                            {item?.is_favorite && (
                              <span
                                className="my-auto"
                                onClick={() =>
                                  handleFav(
                                    nReport?.details?.latest_meta_data
                                      ?.is_favorite == true
                                      ? false
                                      : true
                                  )
                                }
                              >
                                <FaStar
                                  className={`${
                                    item?.is_favorite && "text-blue-400"
                                  } my-auto text-xs cursor-pointer ml-2`}
                                />
                              </span>
                            )}
                          </div>
                          <div className="text-xs">
                            {item?.latest_news_summary?.length > 10
                              ? `${item?.latest_news_summary.slice(0, 30)}...`
                              : `${item?.latest_news_summary}`}
                          </div>
                        </div>
                        <div className="ml-auto my-auto text-[var(--brand-primary)] font-[600] text-sm">
                          {item?.no_of_news_updates > 0 &&
                            `+${item?.no_of_news_updates}`}
                        </div>
                      </div>
                    </div>
                  )
                );
              })}
          </div>
        )}
      </div>

      <div className="pt-20 w-[80%] bg-[#f3f4f6] overflow-y-auto h-[99vh] px-20">
        {nReport?.details?.latest_meta_data?.target?.length > 0 && (
          <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
            <div className="text-lg leading-7 font-[500] my-auto flex">
              {nReport?.details?.latest_meta_data?.target}
              {
                <span
                  className="my-auto"
                  onClick={() =>
                    handleFav(
                      nReport?.details?.latest_meta_data?.is_favorite == true
                        ? false
                        : true
                    )
                  }
                >
                  <FaStar
                    className={`${
                      nReport?.details?.latest_meta_data?.is_favorite
                        ? "text-blue-400"
                        : "text-gray-400"
                    } my-auto text-base cursor-pointer ml-2`}
                  />
                </span>
              }
            </div>
            {/* <button
              type="button"
              className="mr-4 inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] px-3 py-2 text-sm font-semibold text-white shadow-sm"
              onClick={()=>{handleSubmit();}}
              >
            Save Changes
          </button>             */}
          </div>
        )}
        <div>
          {/* logic for empty cards */}
          {isLoading && (
            <div className="flex justify-center">
              <img src={Jump} className="w-48 h-48 mt-48 " />
            </div>
          )}

          {/* {nReport?.details?.articles_report?.length == null && !isLoading && (
            <div className="text-xl pt-48 mx-auto flex justify-center">
              Please complete setup to generate report.
            </div>
          )} */}
          {nReport?.details == null && !isLoading && (
            <div className="text-xl pt-48 mx-auto flex justify-center">
              {nReport?.message}
            </div>
          )}
          {nReport?.details?.articles_report?.length == 0 && !isLoading && (
            <div className="text-xl pt-48 mx-auto flex justify-center">
              No relevant Signals were found. Please check back again tomorrow!
            </div>
          )}
          {nReport?.details?.articles_report?.length > 0 &&
            !isLoading &&
            nReport?.details?.articles_report?.map((item) => {
              return (
                <main className="p-4 space-y-4 !w-full">
                  <div className="bg-white px-10 py-9 shadow rounded-xl">
                    <div className="flex">
                      <div className="text-gray-400 mb-1">
                        {item?.human_date}
                      </div>
                      {/* <div className="rounded-md bg-yellow-100 text-yellow-500 px-2 py-1 max-sm:text-sm max-sm:mb-3">{item?.report_meta_data?.target}</div> */}
                      {/* <div className="ml-auto flex flex-end bg-[#F1F5F9] p-4 rounded-lg">
                        <LuSendHorizonal className="text-gray-400 text-lg" />
                      </div> */}
                    </div>
                    <div
                      onClick={() => window.open(item?.sourceUrl, "_blank")}
                      className="text-xl leading-7 font-semibold mb-6 cursor-pointer"
                    >
                      {item?.title}
                    </div>
                    <div className="flex gap-4 flex-wrap mb-4">
                      {item?.triggers_its_relevant_to?.map((tItem) => {
                        return (
                          <div className="rounded-md capitalize bg-yellow-100 text-yellow-500 px-2 py-1 max-sm:text-sm max-sm:mb-3">
                            {tItem}
                          </div>
                        );
                      })}
                      {item?.companies_name_mentioned_in_news?.map((tItem) => {
                        return (
                          <div className="rounded-md bg-[#ECFEFF] text-cyan-500 px-2 py-1 max-sm:text-sm max-sm:mb-3">
                            {tItem}
                          </div>
                        );
                      })}
                    </div>
                    <div className="text-gray-400">Summary</div>
                    <div className="text-black">
                      <p>{item?.summary}</p>
                    </div>

                    <div className="pr-6 flex pl-4 mt-8">
                      <img
                        src={Logo}
                        alt="BotIcon"
                        className="mb-auto mr-2 w-10 h-10"
                      />
                      <div className="first-left-response ml-4 !bg-[var(--brand-primary)] !w-full">
                        <Icon.CaretRightFill
                          className="left-icon-triangle-conversation"
                          color="var(--brand-primary)"
                        />
                        <p className="ai-heading text-white">SIA Says</p>
                        <p className="ai-response !text-white">
                          {item?.relevance}
                        </p>
                      </div>
                    </div>

                    {
                      <div className="mt-6">
                        <div className="mb-2 text-gray-400">Talking Points</div>
                        {/* {item?.action_items?.success_metrics?.length > 0 &&  <>
            <div className="list-decimal text-sm font-bold mb-1">
           B. Success Metrics
            </div>
            <div className="list-decimal text-sm ml-4">
            {item?.action_items?.success_metrics?.map((action) => {
            return (
              <li>{action}</li>
            )})}
            </div>
            </>} */}
                        {item?.action_items?.clear_value_proposition?.length >
                          0 && (
                          <>
                            <div className="list-decimal text-sm font-bold mb-1">
                              A. Value Proposition
                            </div>
                            <div className="list-decimal text-sm ml-4">
                              {item?.action_items?.clear_value_proposition?.map(
                                (action) => {
                                  return <li>{action}</li>;
                                }
                              )}
                            </div>
                          </>
                        )}
                        {item?.action_items?.tailored_outreach_strategy
                          ?.length > 0 && (
                          <>
                            <div className="list-decimal text-sm font-bold mb-1">
                              B. Outreach Strategy
                            </div>
                            <div className="list-decimal text-sm ml-4">
                              {Array.isArray(
                                item?.action_items?.tailored_outreach_strategy
                              )
                                ? item?.action_items?.tailored_outreach_strategy?.map(
                                    (action) => {
                                      return <li>{action}</li>;
                                    }
                                  )
                                : item?.action_items
                                    ?.tailored_outreach_strategy}
                            </div>
                          </>
                        )}
                      </div>
                    }

                    {item?.leads_info?.length > 0 && (
                      <>
                        <hr className="my-8" />
                        <div className="text-gray-400 mb-3">Relevant Leads</div>
                        <div className="flex flex-wrap gap-6">
                          {item?.leads_info.map((eitem) => {
                            return (
                              <div className="border-solid border-gray-100 border-2 rounded-md py-2 px-2 flex justify-between">
                                <div className="rounded-full bg-yellow-100 py-2 px-3 text-yellow-500 text-lg">
                                  {eitem?.email.slice(0, 2)}
                                </div>
                                <div className="flex-col ml-3 my-auto">
                                  {eitem?.first_name && (
                                    <div className="font-[600] text-sm">{`${eitem?.first_name}`}</div>
                                  )}
                                  <div className="font-[400] text-xs">
                                    {eitem?.email}
                                  </div>
                                </div>
                                <div className="flex gap-x-2 my-auto ml-3 text-gray-400">
                                  <MdOutgoingMail
                                    className="text-2xl cursor-pointer"
                                    onClick={() => {
                                      handleGmail(
                                        "email",
                                        item?.article_id,
                                        eitem?.lead_id
                                      );
                                      setOpen(true);
                                    }}
                                  />
                                  <FaLinkedin
                                    className="text-lg my-auto cursor-pointer"
                                    onClick={() => {
                                      handleGmail(
                                        "linkedin",
                                        item?.article_id,
                                        eitem?.lead_id
                                      );
                                      setOpenLinkdin(true);
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </>
                    )}
                  </div>
                </main>
              );
            })}
        </div>
      </div>

      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => {
            setOpen(false);
          }}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-[#f2f2f2] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-3xl sm:py-16 sm:px-12">
                  <div className="flex flex-col">
                    <div className="flex justify-between my-auto mb-4">
                      <div className="flex my-auto">
                        <div className="font-semibold text-lg pr-3 my-auto">
                          Smart AI-Generated email for
                        </div>
                        <div className="rounded-full bg-yellow-100 p-2 text-yellow-500 text-sm my-auto">
                          {eData?.details?.email?.slice(0, 2)}
                        </div>
                        <div className="font-semibold text-lg ml-2">
                          {eData?.details?.email}
                        </div>
                      </div>
                      <div className="flex">
                        <div
                          onClick={() =>
                            composeEmail(
                              eData?.details?.email,
                              eData?.details?.email_subject,
                              eData?.details?.email_content
                            )
                          }
                          className="ml-auto border-solid border-[1px] border-gray-400 flex flex-end p-2 rounded-lg mr-4"
                        >
                          <LuSendHorizonal className="text-gray-400 text-lg cursor-pointer" />
                        </div>
                        {/* <div className="ml-auto border-solid border-[1px] border-gray-400 flex flex-end p-2 rounded-lg">
                          <MdOutlineEdit  className="text-gray-400 text-lg cursor-pointer" />
                        </div> */}
                      </div>
                    </div>
                    <hr></hr>
                    {isLoading ? (
                      <div className="my-44 mx-auto">
                        <div className="chat-lds-dual-ring my-44"></div>
                        {/* <div className="chat-overlay-bg py-28"></div> */}
                      </div>
                    ) : (
                      <>
                        <div className="font-semibold text-xl mt-2 pb-3">
                          {eData?.details?.email_subject}
                        </div>
                        <hr></hr>
                        <div className="h-[50vh] removeScroll overflow-y-auto py-3">
                          <Markdown options={options}>
                            {eData?.details?.email_content}
                          </Markdown>
                          {/* {eData?.details?.email_content} */}
                        </div>
                      </>
                    )}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      <Transition.Root show={openLinkdin} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => {
            setOpenLinkdin(false);
          }}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-[#f2f2f2] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-3xl sm:py-16 sm:px-12">
                  <div className="flex flex-col">
                    <div className="flex justify-between my-auto mb-4">
                      <div className="flex my-auto">
                        <div className="font-semibold text-lg pr-3 my-auto">
                          Smart AI-Generated Linkedin note for
                        </div>
                        <div className="rounded-full bg-yellow-100 p-2 text-yellow-500 text-sm my-auto">
                          {eData?.details?.email?.slice(0, 2)}
                        </div>
                        <div className="font-semibold text-lg ml-2 my-auto">
                          {eData?.details?.email}
                        </div>
                      </div>
                      <div className="flex">
                        {/* <div className="ml-auto border-solid border-[1px] border-gray-400 flex flex-end p-2 rounded-lg">
                          <MdOutlineEdit  className="text-gray-400 text-lg cursor-pointer" />
                        </div> */}
                      </div>
                    </div>
                    <hr></hr>

                    {isLoading ? (
                      <div className="my-44 mx-auto">
                        <div className="chat-lds-dual-ring my-44"></div>
                        {/* <div className="chat-overlay-bg py-28"></div> */}
                      </div>
                    ) : (
                      <div className="h-[50vh] removeScroll overflow-y-auto py-3">
                        <Markdown options={options}>
                        {eData?.details?.message}
                        </Markdown>

                        {/* {eData?.details?.message} */}
                      </div>
                    )}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default Intel;
